import { merge, isFunction } from 'lodash';
import { DEFAULT_REPORTED_CHANNELS } from './constants';

class EventsReporter {

    enrich({ sourceInfo }) {
        this.baseEnrichmentParams = { sourceInfo };
    }

    /**
     * Reports event to all reporting channels (grafana, bigQuery, mixpanel).
     *
     * In case no specific channel is supplied, the event is reported to all channels.
     *
     * @param {String} eventKey
     * @param {Object} enrichmentParams
     * @param {Array} reportingChannels
     */
    report(eventKey, enrichmentParams = {}, reportingChannels = DEFAULT_REPORTED_CHANNELS) {
        if (!eventKey) {return;}

        reportingChannels.forEach(({ events, reporter }) =>
            this.reportEvent(
                events[eventKey],
                reporter,
                merge({}, this.baseEnrichmentParams, enrichmentParams)
            )
        );
    }

    reportEvent(event, reporter, enrichmentParams) {
        if (!event) {return;}

        const enrichedEvent = isFunction(event)
            ? event(enrichmentParams)
            : event;

        reporter(enrichedEvent);
    }

}

export default new EventsReporter();
